<script setup>
import { ref } from 'vue';
import { fieldEmits, fieldProps, useField } from '@/composables/form/field';

const element = ref();
const props = defineProps(fieldProps());
const emit = defineEmits(fieldEmits());

const set = (value) => element.value.value = value;
const castStateUsing = (state) => state ?? '';

const field = useField({ props, emit, set, castStateUsing });
</script>

<template>
    <input
        :aria-label="field.label && field.hideLabel ? field.label : undefined"
        ref="element"
        :id="field.id"
        :name="field.name"
        type="hidden" />
</template>
